import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Widget } from '@niche-js/core/components';

var styles = {"container":"niche-js-block-images-container"};

var propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    media: PropTypes.shape({
      url: PropTypes.string
    })
  })),
  className: PropTypes.string
};
var defaultProps = {
  items: null,
  className: null
};
function Images(_ref) {
  var items = _ref.items,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(Widget, {
    className: classNames([styles.container, _defineProperty({}, className, className !== null)])
  }, items !== null ? items.map(function (_ref3) {
    var media = _ref3.media;
    return /*#__PURE__*/React.createElement("img", {
      src: media.url,
      alt: media.alt || 'Media'
    });
  }) : null);
}
Images.propTypes = propTypes;
Images.defaultProps = defaultProps;

export { Images as default };
